export const institutionReducerKey = 'institutionReducerKey';
export const institutionReducerType = 'institutionReducerType';
export const institutionSetIsLoadingReducerType = 'institutionSetIsLoadingReducerType';
export const institutionSetNotificationsReducerType = 'institutionSetNotificationsReducerType';
export const institutionSetIpAddressReducerType = 'institutionSetIpAddressReducerType';
export const institutionSetInstitutionsForSearchReducerType = 'institutionSetInstitutionsForSearchReducerType';
export const institutionSetInstitutionsGroupsReducerType = 'institutionSetInstitutionsGroupsReducerType';
export const institutionSetActualDataReducerType = 'institutionSetActualDataReducerType';
export const institutionResetStateReducerType = 'institutionResetStateReducerType';

export const NOVARTIS_ERROR = 'Application auth endpoint error: novartis';
export const NOVARTIS_ERROR_MESSAGE =
  "You do not have the required privileges to access NIBR's Chemistry eLN data.  Please visit www.reaxys.com  to conduct your substances, reactions, documents and bioactivity data searches";
export const DEFAULT_ERROR_MESSAGE = 'Your attempt to sign in via institution has failed, please try again';
